<script>
import BasePopup from '@/components/BasePopup.vue';

export default {
  name: 'PopupWrapper',
  components: { BasePopup },
  controller: null,
  data() {
    return {
      isOpened: false,
      wrappable: null,
      popupOptions: {},
    };
  },
  computed: {
    props() { return this.wrappable?.props ?? {}; },
  },
  methods: {
    open(wrappable) {
      this.wrappable = wrappable;
      this.popupOptions = wrappable.options ?? {};
      this.isOpened = true;

      this.$nextTick(() => {
        const params = wrappable.params ?? {};
        this.$refs.wrappable.init?.(params); // eslint-disable-line
      });

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close(result) {
      this.isOpened = false;
      this.$options.controller.resolve(result);
    },
  },
};
</script>

<template lang="pug">
  BasePopup(@close="close(false)" v-if="isOpened" v-bind="popupOptions")
    component(:is="wrappable.component" v-bind="props" @finish="close" ref="wrappable")
</template>

<style scoped lang="scss">

</style>
